import React from 'react';
import { connect } from 'react-redux';
import * as actions from "store/actions/index";
import ctypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import * as DataUtil from 'Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil';
import * as CustomForm from 'Flow2/components/CustomCollections/CustomDataControllers/CustomFormController';
import { getArchivNrPreDD } from 'Flow2/components/Share/FlexUpload/FlexUploadHelper/FlexUploadHelper';
import * as fTypes from "Flow2/components/Share/FlexUpload/FlexUploadConfig/FlexUploadTypes";
import { injectIntl } from 'react-intl';


class FlexUploadHandler extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getTabs = ({ data }) => {
        let tabs = [];
        data.map(item => {
            if (item.tab) tabs.push({ "name": item.tab, "lgMsId": item.tab });
        });
        tabs = tabs.reduce((acc, item) => {
            if (!acc.find(el => el.name == item.name)) acc.push(item);
            return acc;
        }, []);
        return tabs;
    }

    checkUploadData = ({ data, addData }) => {
        let uploadConfig = [];
        let defType = "CustomDataInput";
        let formTabs = this.getTabs({ data: data });
        uploadConfig = CustomForm.initFormDataForApp({
            formName: ctypes.APP_FORM_UPLOAD, formData: data, formTabs,
            user: this.props.user, users: this.props.users, lg: this.props.lg
        });

        if (uploadConfig) {
            uploadConfig = uploadConfig.map(item => {
                if (item.data && item.data.length) {
                    item.data = item.data.map(el => {
                        if (!el.inputType) el.inputType = defType;
                        if (addData && el.name == addData.field) {
                            el.data = addData.value || '';
                            el.inputType = addData.inputType || defType;
                        }
                        return el;
                    });
                }
                return item;
            });
            this.props.addApiUploadConfig(uploadConfig);
        }
    }

    handleFlex = ({ ddname, ddvalue = '' }) => {
        let addData;
        if (ddname == ctypes.MBOX) {
            let archivData = getArchivNrPreDD({ mbox: ddvalue });
            addData = { field: fTypes.ARCHIV_FIELD, value: archivData, inputType: 'CustomDropDown' };
            this.checkUploadData({ data: this.props.meta.clip, addData });
        }
    }

    checkAllConfig = ({ item, ddvalue }) => {
        let ddvalueArr = ddvalue.split(";");
        if (item.params && item.params.condition && item.params.condition.content) {
            let contentArr = item.params.condition.content;
            if (typeof contentArr === 'string') contentArr = contentArr.split(",");
            if (contentArr && contentArr.length) {
                let found = false;
                contentArr.forEach(ct => {
                    if (ddvalueArr.find(v => v == ct)) found = true;
                })
                if (found) return true
            }
        }
        return false;
    }

    handleAllFlex = ({ ddname, ddvalue }) => {
        let clipConfig;
        if (ddname == ctypes.MBOX) {
            if (this.props.meta && this.props.meta.clip) {
                clipConfig = [...this.props.meta.clip];
                if (ddvalue && ddvalue.trim()) {
                    clipConfig = this.props.meta.clip.filter(item => {
                        if (item.field === ddname) return true;
                        if (this.checkAllConfig({ item, ddvalue })) return true;
                        return false;
                    });

                    if (clipConfig && clipConfig.length) {
                        clipConfig = clipConfig.map(item => ({ ...item, upload: true }));
                    }
                    //Search
                    this.checkUploadData({ data: clipConfig });
                } else {
                    this.checkUploadData({ data: this.props.meta.clip });
                }
            }
        }
    }

    handlePMDBFlex = ({ ddname = '', ddvalue = '' }) => {
        if (this.props.uploadConfig && this.props.uploadConfig.length && ddname == ctypes.LONG_DESC_ES) {
            let meta = this.props.meta.clip;
            let found = meta.find(el => el.params && el.params.condition && el.params.condition[ctypes.LONG_DESC_ES]);
            if (found) {
                let uploadConfig;
                if (this.props.flexObjects.originalUploadConfig) {
                    uploadConfig = [...this.props.flexObjects.originalUploadConfig];
                } else {
                    uploadConfig = [...this.props.uploadConfig];
                }
                uploadConfig = uploadConfig.map(item => {
                    if (item.data && item.data.length) {
                        if (!ddvalue || (ddvalue && (!found.params.condition[ctypes.LONG_DESC_ES].some(entry => entry == ddvalue)))) {
                            let tmp = [...item.data];
                            tmp = tmp.filter(el => el.name !== found.field)
                            return { ...item, data: tmp }
                        }
                    }
                    return item;
                });
                this.props.addApiUploadConfig(uploadConfig);
            }
        }
    }

    componentDidUpdate(prev) {
        const { flexUpload } = this.props.flexObjects;
        if (prev.flexObjects.flexUpload !== flexUpload) {
            if (DataUtil.isPorscheArchiv()) this.handleFlex({ ...flexUpload });
            if (DataUtil.isDZA()) this.handleAllFlex({ ...flexUpload });
            if (DataUtil.isPMDB()) this.handlePMDBFlex({ ...flexUpload })
        }
    }

    componentDidMount() {

    }

    render() {
        if (DataUtil.isPorscheArchiv() || DataUtil.isDZA()) {
            return (
                <div className="FlexUploadHandler">
                </div>)
        }
        return null;
    }
}

const mapStateToprops = (state) => ({
    flexObjects: state.flex.flexObjects,
    loading: state.flex.loading,
    meta: state.metadata.config,
    users: state.admin.users,
    user: state.auth.user,
    lg: state.ui.language,
    uploadConfig: state.ui.uploadConfig,
    meta: state.metadata.config,
})

const mapDispatchToProps = (dispatch) => ({
    updateFlexObjects: (obj) => dispatch(actions.updateFlexObjects(obj)),
    addApiUploadConfig: (uploadConfig) => dispatch(actions.addApiUploadConfig(uploadConfig)),
})

export default connect(mapStateToprops, mapDispatchToProps)(injectIntl(FlexUploadHandler));